import { render, staticRenderFns } from "./ActivityComments.vue?vue&type=template&id=71e6e926&"
import script from "./ActivityComments.vue?vue&type=script&lang=js&"
export * from "./ActivityComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports